import { Alert, Button, Stack, Typography } from '@mui/material';
import { useLazyVerifyAdminEmailQuery } from 'api/client-domain/client-domain';
import LoginLayout from 'components/layouts/login-layout/login-layout.component';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useNavigate, useSearchParams } from 'react-router-dom';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [trigger, { isLoading, isSuccess, error }] =
    useLazyVerifyAdminEmailQuery();
  const [searchParams] = useSearchParams();

  const onClick = useCallback(async () => {
    trigger({ code: searchParams.get('code') });
  }, [searchParams, trigger]);

  const onLoginClick = () => {
    navigate('/login');
  };

  useEffect(() => {
    if (error?.status === 401) {
      enqueueSnackbar(t('page.verifyEmail.error'), {
        severity: 'error',
      });
    }
  }, [enqueueSnackbar, error, t]);

  return (
    <LoginLayout>
      {isSuccess ? (
        <Stack spacing={2}>
          <Alert severity="success">
            <Stack spacing={1}>
              <Typography>{t('page.verifyEmail.success.message')}</Typography>
            </Stack>
          </Alert>
          <Button onClick={onLoginClick}>
            {t('page.verifyEmail.success.login.button')}
          </Button>
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Typography textAlign="center">
            {t('page.verifyEmail.message')}
          </Typography>
          <Button onClick={onClick} disabled={isLoading}>
            {t('page.verifyEmail.button')}
          </Button>
        </Stack>
      )}
    </LoginLayout>
  );
};
export default VerifyEmail;
